import { render } from "./JPaginationBox.vue?vue&type=template&id=0f41e3ce&scoped=true"
import script from "./JPaginationBox.vue?vue&type=script&lang=js"
export * from "./JPaginationBox.vue?vue&type=script&lang=js"

import "./JPaginationBox.vue?vue&type=style&index=0&id=0f41e3ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f41e3ce"]])

export default __exports__